export function defaultSearchValues() {
    return Object.freeze({
      keyword:"",
      trialStatus: "ar",
      trialCreationDate: "0",
      zipCode: "",
      distance: 0,
      measure: "mi",
      country: "Global"
    })};